import React from 'react';
import { Reveal } from './Reveal';
const bonusImages = ['https://cdn.magicpatterns.com/uploads/7qNQ7ZAseEwHWtmBY6gcEQ/ChatGPT_Image_19_jul_2026,_08_37_36_p.m..png', 'https://cdn.magicpatterns.com/uploads/eCPKJ5njBUoTpkmwkzXimG/ChatGPT_Image_19_jul_2026,_08_37_46_p.m..png', 'https://cdn.magicpatterns.com/uploads/7t3gstF5LciNbv83bStCL6/ChatGPT_Image_19_jul_2026,_08_37_55_p.m..png', 'https://cdn.magicpatterns.com/uploads/kGrV15kHyhv89Ppkw5DQUa/ChatGPT_Image_19_jul_2026,_08_38_01_p.m..png', 'https://cdn.magicpatterns.com/uploads/5RDiC7VRPC737zFajUvboE/ChatGPT_Image_19_jul_2026,_08_38_09_p.m..png'];
export function Bonuses() {
  return <section className="w-full bg-navy px-4 py-20 text-white sm:py-24" style={{
    backgroundColor: "#BECBE9",
    backgroundImage: "none"
  }} data-id="element-19" data-mp="3o3ptu3kvq2xz">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="1m9qixjbo5nlt">
        <Reveal className="text-center" data-id="element-21" data-mp="1mart7lkv262h">
          <h2 className="font-serif text-4xl sm:text-5xl" style={{
          color: "#0F0101"
        }} data-id="element-22" data-mp="1r933fxf2iil8">🎁 5 Exclusive <span className="text-sage-light" style={{
            color: "#034135"
          }} data-id="element-23" data-mp="3ieg9h9e6kh3h">Bonus Resource Kits</span></h2>
          <p className="mt-3 whitespace-nowrap text-xs text-white/70" style={{
          color: "#210101"
        }} data-id="element-24" data-mp="3dflel92xv230">Included FREE with your purchase</p>
        </Reveal>

        <div className="mx-auto mt-9 flex max-w-5xl flex-col items-center gap-7 sm:gap-8" data-id="element-25" data-mp="3r68h7cbtlc4d">
          {bonusImages.map((image, index) => <Reveal key={image} delay={index * 0.04} className="w-full" data-id="element-26" data-mp="3n7iu2s0zcg7j" data-mpi={index}>
              <img src={image} alt={`Exclusive stretching bonus resource kit ${index + 1}`} className="mx-auto w-[94%] rounded-2xl shadow-premium" data-id="element-27" data-mp="2zg3uv84i2f0i" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}